import assign from 'lodash/object/assign';
import zipObject from 'lodash/array/zipObject';
import map from 'lodash/collection/map';
import padLeft from 'lodash/string/padLeft';

const propertyNameMap = {
  ExpiryYear: 'expiry',
  ExpiryMonth: 'expiry',
  CardNumber: 'number',
  AcceptBankAccountTerms: 'accepted_terms',
  BSBNumber: 'bsb_number',
  BankAccountNumber: 'account_number',
  BankAccountName: 'account_name'
};

/**
 * Translate bpoint property names to internal names
 * @param propertyName
 * @returns {*}
 */
function transformPropertyName(propertyName) {
  if (propertyName in propertyNameMap) {
    return propertyNameMap[propertyName];
  }
  return propertyName;
}

export default ngModule => {

  /**
   * BPointApi
   *
   * Provides a wrapper around the BPoint API javascript code and creates
   * the necessary authKey for you before tokenising cards.
   *
   * Only the processAddToken for data vault is implemented.
   */
  ngModule.factory('BPointApi', function ($http, $q) {

    /**
     * Create an authkey for use with other API calls
     */
    function getAuthKey() {
      const deferred = $q.defer();
      $http.post('/bpoint/datavaultauth').then(response => {
        console.log('response', response)
        if (response.status == 200) {
          deferred.resolve(response.data.authKey);
          return;
        }
        deferred.reject(response.data.message || response.data);
      })
      return deferred.promise;
    }

    /**
     * Process add token call with BPoint. This depends upon the bpoint javascript
     * being available which is included manually as a script tag.
     * @param {Object} details as per documentation; either bank account or credit card details
     * @returns {deferred.promise|{then, catch, finally}|{then}|{then, always}}
     */
    function processAddToken(details) {
      console.log('process add token', details)

      const deferred = $q.defer();

      // Handles response from bpoint
      const processAddTokenCallback = result => {
        console.log(result)
        if (result.AjaxResponseType == 0 && result.ApiResponseCode == 0) { //AJAX call was successful
          deferred.resolve(result);
        } else {
          const errors = zipObject(map(result.Errors,
            error => [transformPropertyName(error.PropertyName), [error.Message]]));
          deferred.reject(errors);
        }
      };

      const onAuthKeySuccess = authKey => {
        console.log('got key', authKey);
        // AuthKey generated, can now attempt to process token
        CBA.ProcessAddToken(assign(details, {
          AuthKey: authKey,
          CallbackFunction: processAddTokenCallback
        }));
      };
      const onAuthKeyError = error => {
        deferred.reject(error);
      };
      // Need an auth key before we can attempt to process with bpoint
      getAuthKey().then(onAuthKeySuccess, onAuthKeyError);

      return deferred.promise;
    }

    class BPointApi {

      tokeniseCreditCard(card_details, customer_details = {}) {
        const {expiry, name, number} = card_details,
              {email_address, reference} = customer_details;
        const [year, month] = expiry.split('-');
        const data = {
          Type: 'CREDITCARD',
          CardHolderName: name,
          CardNumber: number,
          // According to CBA support this should be a string padded with 0's rather than a Number which is what
          // the documentation says
          ExpiryMonth: padLeft(month, 2, '0'),
          // As above, leave as string rather than Number. Only pass through last 2 digits (eg. 17 for 2017)
          ExpiryYear: year.substr(2),
          Crn1: reference,
          EmailAddress: email_address
        };
        return processAddToken(data);
      }

      tokeniseBankAccount(account_details, customer_details = {}) {
        const {account_name, account_number, bsb_number, accepted_terms} = account_details,
              {email_address, reference} = customer_details;

        return processAddToken({
          Type: 'BANKACCOUNT',
          BSBNumber: bsb_number,
          BankAccountNumber: account_number,
          BankAccountName: account_name,
          AcceptBankAccountTerms: accepted_terms,
          Crn1: reference,
          EmailAddress: email_address
        });
      }

    }

    return new BPointApi();

  });


};



// WEBPACK FOOTER //
// ./src/services/bpoint-service.js